import React from 'react';
import { PaymentProcessContext } from '../context/PaymentProcessContext';

export function usePaymentProcess() {
  const {
    remainingAmount,
    setRemainingAmount,
    benefitsAmount,
    setBenefitsAmount,
    scrollTargetRef,
    handleScroll,
    refetchGtShopCartPaymentStatus,
  } = React.useContext(PaymentProcessContext);
  return {
    remainingAmount,
    setRemainingAmount,
    benefitsAmount,
    setBenefitsAmount,
    scrollTargetRef,
    handleScroll,
    refetchGtShopCartPaymentStatus,
  };
}
